(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-letter.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-letter.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const _ReactWindow = ReactWindow,
  FixedSizeList = _ReactWindow.FixedSizeList;
const namesByFirstLetter = svs.tickets_giftshop.gift.giftform.date_selector.namesByDateData.namesByFirstLetter;
const DATE_TIME_AND_NAME = svs.tickets_giftshop.constants.names.DATE_TIME_AND_NAME;
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useCallback = _React.useCallback;
const NAME_DAY_BY_LETTER = svs.tickets_giftshop.constants.dateSelectorKey.NAME_DAY_BY_LETTER;
const getNextChar = (char, availableLetters) => {
  const nextLetter = String.fromCharCode(char.charCodeAt(0) + 1);
  return availableLetters.includes(nextLetter) ? nextLetter : getNextChar(nextLetter, availableLetters);
};
const getPrevChar = (char, availableLetters) => {
  const nextLetter = String.fromCharCode(char.charCodeAt(0) - 1);
  return availableLetters.includes(nextLetter) ? nextLetter : getPrevChar(nextLetter, availableLetters);
};
const Row = _ref => {
  let index = _ref.index,
    data = _ref.data,
    style = _ref.style;
  const classNames = ['tg-name-day-by-letter-row-item'];
  const isActive = data.isActive,
    selectDate = data.selectDate,
    namesByFirstLetterData = data.namesByFirstLetterData;
  const _namesByFirstLetterDa = namesByFirstLetterData[index],
    date = _namesByFirstLetterDa.date,
    name = _namesByFirstLetterDa.name;
  const _date$split = date.split('/'),
    _date$split2 = _slicedToArray(_date$split, 2),
    day = _date$split2[0],
    month = _date$split2[1];
  const active = isActive(day, month, name);
  if (active) {
    classNames.push('tg-name-by-letter-selected fc-white');
  } else {
    classNames.push('fc-black');
  }
  return React.createElement("div", {
    className: "tg-name-day-by-letter-row",
    style: style
  }, React.createElement("a", {
    className: classNames.join(' '),
    href: "",
    onClick: e => {
      e.preventDefault();
      selectDate(day, month, name);
    },
    tabIndex: "0"
  }, React.createElement("div", {
    className: "w50"
  }, React.createElement("b", null, "".concat(name, " "))), React.createElement("div", {
    className: "w50"
  }, React.createElement("span", null, "".concat(day, " ").concat(new Intl.DateTimeFormat('sv-SE', {
    month: 'long'
  }).format(new Date(0, month - 1)))))));
};
const Column = _ref2 => {
  let index = _ref2.index,
    data = _ref2.data,
    style = _ref2.style;
  const isActive = data.isActive,
    setLetter = data.setLetter,
    availableLetters = data.availableLetters;
  const letterOption = availableLetters[index];
  const active = isActive(letterOption);
  return React.createElement("a", {
    className: "tg-name-day-by-letter-col ".concat(active ? 'tg-name-day-by-letter-col-active' : 'fc-black'),
    href: "",
    onClick: e => {
      e.preventDefault();
      setLetter(letterOption);
    },
    style: style
  }, React.createElement("span", {
    className: "tg-name-day-by-letter-pagination-header"
  }, letterOption));
};
const NameDayByLetter = _ref3 => {
  let date = _ref3.date,
    _ref3$nameDayName = _ref3.nameDayName,
    nameDayName = _ref3$nameDayName === void 0 ? '' : _ref3$nameDayName,
    onInputChange = _ref3.onInputChange,
    _ref3$minDate = _ref3.minDate,
    minDate = _ref3$minDate === void 0 ? svs.utils.date.SimpleDate(new Date()) : _ref3$minDate;
  const listRef = useRef(null);
  const letterListRef = useRef(null);
  const _useState = useState(() => Object.keys(namesByFirstLetter).sort()),
    _useState2 = _slicedToArray(_useState, 1),
    availableLetters = _useState2[0];
  const _useState3 = useState(nameDayName && nameDayName[0] || 'A'),
    _useState4 = _slicedToArray(_useState3, 2),
    letter = _useState4[0],
    setLetter = _useState4[1];
  const disableIncrement = letter === 'Ö';
  const disableDecrement = letter === 'A';
  const formatDate = useCallback((day, month) => {
    const date = new Date();
    date.setMonth(month === 1 ? 0 : month - 1);
    date.setDate(day);
    const year = svs.utils.date.SimpleDate(date) < minDate ? date.getFullYear() + 1 : date.getFullYear();
    return "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day);
  }, [minDate]);
  useEffect(() => {
    if (listRef.current && nameDayName) {
      const selectedLetterNames = namesByFirstLetter[letter];
      const nameIndex = selectedLetterNames.findIndex(_ref4 => {
        let name = _ref4.name;
        return name === nameDayName;
      });
      listRef.current.scrollToItem(nameIndex, 'smart');
    } else {
      listRef.current.scrollToItem(0);
    }
  }, [letter]);
  useEffect(() => {
    if (letterListRef.current) {
      const letterIndex = availableLetters.indexOf(letter);
      letterListRef.current.scrollToItem(letterIndex + 1, 'center');
    }
  }, [availableLetters, letter]);
  const selectDate = useCallback((day, month, name) => {
    const date = formatDate(day, month);
    onInputChange({
      target: {
        value: {
          date,
          time: '08:00',
          nameDayName: name,
          dateSelectorUsed: NAME_DAY_BY_LETTER
        },
        name: DATE_TIME_AND_NAME
      }
    });
  }, [onInputChange, formatDate]);
  const letterData = useMemo(() => ({
    availableLetters,
    setLetter,
    isActive: letterOption => letter === letterOption
  }), [availableLetters, setLetter, letter]);
  const data = useMemo(() => ({
    isActive: (day, month, name) => date === formatDate(day, month) && name === nameDayName,
    selectDate,
    namesByFirstLetterDataCount: Object.keys(namesByFirstLetter[letter]).length,
    namesByFirstLetterData: namesByFirstLetter[letter]
  }), [date, letter, nameDayName, formatDate, selectDate]);
  return React.createElement("div", {
    className: "tg-date-input gutter-sm-2"
  }, React.createElement("div", {
    className: "tg-name-day-by-letter-pagination padding-2"
  }, React.createElement(IconButton, {
    disabled: disableDecrement,
    onClick: e => {
      e.preventDefault();
      setLetter(getPrevChar(letter, availableLetters));
    }
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-left"
  })), React.createElement(FixedSizeList, {
    className: "List tg-name-day-by-letter-list",
    height: 24,
    itemCount: letterData.availableLetters.length,
    itemData: letterData,
    itemSize: 24,
    layout: "horizontal",
    ref: letterListRef,
    style: {
      overflowX: 'hidden'
    },
    width: 285
  }, Column), React.createElement(IconButton, {
    disabled: disableIncrement,
    onClick: e => {
      e.preventDefault();
      setLetter(getNextChar(letter, availableLetters));
    }
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-right"
  }))), React.createElement(FixedSizeList, {
    className: "List tg-date-selector-inverted-box-shadow",
    height: 360,
    itemCount: data.namesByFirstLetterDataCount,
    itemData: data,
    itemSize: 36,
    layout: "vertical",
    ref: listRef
  }, Row));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.NameDayByLetter = NameDayByLetter;

 })(window);